'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetUserMe } = useUserService();
  const { data: user, isLoading } = useGetUserMe();
  const isAuthenticated = Boolean(user);

  return { isAuthenticated, user, isLoading };
};
